import React, { useState, useEffect, useRef } from "react";
import { PaginationProps } from "./type";
import "./index.css";
import "../../styles/animation.css";
import "../../styles/pagination.scss";
import { CSSTransition } from "react-transition-group";
import Button from "../Button";

const Pagination = ({
  totalPage,
  onChange,
  style = {},
  numberOfPage = 5,
}: PaginationProps) => {
  const pageRef: any = useRef();
  const [padding, setPadding] = useState(0);
  useEffect(() => {
    setPadding((pageRef.current.offsetWidth - 87) / 2);
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageInput, setPageInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const renderPage = (page: number, index: number) => {
    let classItem = index == 0 ? "page-item border-left" : "page-item";
    if (currentPage == page) {
      classItem += " selected";
    }

    return (
      <span
        className={`normal-button ${classItem}`}
        key={page}
        onClick={onPageChange(page)}
      >
        {page == -1 ? "..." : page}
      </span>
    );
  };
  const onPageChange = (page: number) => (e: any) => {
    if (page == 0 || page > totalPage) return;
    if (page < 1) {
      setIsOpen(true);
      return;
    }
    setCurrentPage(page);
    onChange?.(page);
  };
  const getPageData = () => {
    if (totalPage < numberOfPage) {
      return new Array(totalPage).fill({}).map((_, index) => index + 1);
    }
    if (currentPage > totalPage - numberOfPage) {
      return new Array(numberOfPage)
        .fill({})
        .map((_, index) => totalPage - numberOfPage + index + 1);
    }
    const posMiddle = Math.floor(numberOfPage / 2);
    const res = [];
    for (let i = 0; i < numberOfPage; i++) {
      if (i < posMiddle) res.push(currentPage + i);
      if (i == posMiddle) res.push(-1);
      if (i > posMiddle) res.push(totalPage + i - numberOfPage + 1);
    }
    return res;
  };
  const onTextChange = (e: any) => {
    const val = e.target.value;
    setPageInput(val);
  };
  const onIconClick = (isIncrease: boolean) => () => {
    let val = 0;
    if (pageInput != "") {
      val = parseInt(pageInput);
    }
    const newVal = isIncrease ? val + 1 : val - 1;
    setPageInput(`${newVal < 1 ? 1 : newVal}`);
  };
  const onGoClick = () => {
    if (pageInput == "") return;
    let page = parseInt(pageInput);
    if (page > totalPage) {
      page = totalPage;
    } else if (page < 1) {
      page = 1;
    }
    setCurrentPage(page);
    onChange?.(page);
    setIsOpen(false);
  };
  return (
    <div>
      <div className="pagination" style={style}>
        <span className="normal-button btn-page" onClick={onPageChange(1)}>
          First
        </span>
        <div ref={pageRef} className="pagination-container">
          <i
            className="material-icons normal-button"
            style={styles.icon}
            onClick={onPageChange(currentPage - 1)}
          >
            arrow_left
          </i>
          {getPageData().map(renderPage)}
          <i
            className="material-icons normal-button"
            style={styles.icon}
            onClick={onPageChange(currentPage + 1)}
          >
            arrow_right
          </i>
        </div>
        <span
          className="normal-button btn-page"
          onClick={onPageChange(totalPage)}
        >
          Last
        </span>
      </div>
      {isOpen && (
        <div
          onClick={() => {
            setIsOpen(false);
          }}
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 1,
          }}
        />
      )}
      <CSSTransition
        in={isOpen}
        timeout={300}
        classNames="select"
        unmountOnExit
        onEnter={() => {}}
        onExited={() => {}}
      >
        <div className="page-selection-popup" style={{ paddingRight: padding }}>
          <div className="page-selection-container page-selection-color">
            <span className="select-title">Di chuyển tới</span>
            <div className="select-input">
              <div className="input-field">
                <input
                  className="input"
                  type="number"
                  value={pageInput}
                  onChange={onTextChange}
                  min={1}
                  max={totalPage}
                />
                <i
                  className="material-icons normal-button"
                  style={styles.iconInput}
                  onClick={onIconClick(false)}
                >
                  remove_circle_outline
                </i>
                <i
                  className="material-icons normal-button"
                  style={styles.iconInput}
                  onClick={onIconClick(true)}
                >
                  add_circle_outline
                </i>
              </div>
              <Button label="Go" type="primary" onClick={onGoClick} />
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

const styles: { [name: string]: React.CSSProperties } = {
  icon: {
    fontSize: 20,
    padding: "8px 10px",
  },
  iconInput: {
    fontSize: 20,
    padding: 5,
  },
};

export default Pagination;
